module.exports = __webpack_public_path__ + "static/media/flexion-extension-ratio-right.947ccf97.svg";